var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useRef, useCallback, } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Button, Typography, Tabs, TabList, Tab, Stack, Snackbar, Chip, Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, Sheet, RadioGroup, Grid, Alert, useColorScheme, } from "@mui/joy";
import InfoIcon from "@mui/icons-material/Info";
import Radio, { radioClasses } from "@mui/joy/Radio";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useFlows } from "../../data/hooks/useFlows";
import { TwilioCallComponent } from "../../components/common/TwilioCallComponent";
import Sidepane from "../../components/ui/Sidepane";
import AIAgentsList from "./components/AIAgentList";
import Prompts from "./components/Prompts";
import Plugins from "./components/Plugins";
import axios from "axios";
import { useWebsite } from "../../data/hooks/useWebsite";
import { DOWORK_WIDGET_TESTING, DOWORK_POPUP_OPENED } from "../../constants";
export var AIAgents = function () {
    var _a, _b;
    var _c, _d, _e, _f, _g;
    var _h = useFlows(), flows = _h.flows, voices = _h.voices, templates = _h.templates, getFlows = _h.getFlows, getVoices = _h.getVoices, createNewFlow = _h.createNewFlow, updateFlow = _h.updateFlow, getTemplates = _h.getTemplates, markAsTemplate = _h.markAsTemplate, unMarkAsTemplate = _h.unMarkAsTemplate, getTemplateFlow = _h.getTemplateFlow;
    var _j = useColorScheme(), mode = _j.mode, setMode = _j.setMode;
    var _k = useState(true), isFlowsLoading = _k[0], setIsFlowsLoading = _k[1];
    var _l = useSearchParams(), searchParams = _l[0], setSearchParams = _l[1];
    var _m = useState(null), selectedFlow = _m[0], setSelectedFlow = _m[1];
    var _o = useState(""), flowName = _o[0], setFlowName = _o[1];
    // const [isFlowNameEditing, setIsFlowNameEditing] = useState(false);
    var _p = useState(0), tabIndex = _p[0], setTabIndex = _p[1];
    var _q = useState(true), flowShouldBeSaved = _q[0], setFlowShouldBeSaved = _q[1];
    var _r = useState(false), resetToTemplate = _r[0], setResetToTemplate = _r[1];
    var _s = useState(false), isSaving = _s[0], setIsSaving = _s[1];
    var _t = useState(false), isInfoMessageOpen = _t[0], setInfoMessageOpen = _t[1];
    var _u = useState(), infoMessage = _u[0], setInfoMessage = _u[1];
    var _v = useState(null), errorMessage = _v[0], setErrorMessage = _v[1];
    var _w = useState([]), invalidFields = _w[0], setInvalidFields = _w[1];
    var _x = useState(false), isKnowledgeBaseEnabled = _x[0], setIsKnowledgeBaseEnabled = _x[1];
    var inputRef = useRef(null);
    var _y = useWebsite(), widgetScript = _y.widgetScript, getWidgetScript = _y.getWidgetScript;
    var _z = useState(false), isNewAgentModalOpen = _z[0], setIsNewAgentModalOpen = _z[1];
    var _0 = useState(null), selectedTemplateFlowId = _0[0], setSelectedTemplateFlowId = _0[1];
    var _1 = useState(false), isTemplatesLoading = _1[0], setIsTemplatesLoading = _1[1];
    var _2 = useState(false), isFlowAdding = _2[0], setIsFlowAdding = _2[1];
    var defaultWebhookArgs = {
        httpMethod: "POST",
        url: "",
        headers: {},
        authorizationType: "",
        apiKey: "",
        username: "",
        password: "",
        usernameFieldName: "",
        passwordFieldName: "",
        accessTokenUrl: "",
        accessTokenHttpMethod: "POST",
        accessTokenFieldName: "",
    };
    var defaultEmailPostCallActionArgs = {
        emailTo: "",
    };
    var getArgsObject = function (type) {
        return type === "webhook"
            ? defaultWebhookArgs
            : defaultEmailPostCallActionArgs;
    };
    var setScript = useCallback(function () {
        // Inject script if it's the right path and script is loaded
        if (location.pathname === "/ai-agents" && widgetScript) {
            var script = document.createElement("script");
            script.id = "dowork-script";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = widgetScript
                .replace('<script type="text/javascript">', "")
                .replace("</script>", "");
            document.body.appendChild(script);
        }
    }, [widgetScript]);
    var onTest = useCallback(function () {
        sessionStorage.setItem(DOWORK_POPUP_OPENED, "true");
        sessionStorage.setItem(DOWORK_WIDGET_TESTING, "true");
        setScript();
    }, [setScript]);
    var onMarkAsTemplate = useCallback(function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, markAsTemplate(flowId)];
                case 1:
                    _a.sent();
                    updatedFlow = __assign(__assign({}, selectedFlow), { isWorkspaceTemplate: true });
                    setSelectedFlow(updatedFlow);
                    onSaveFlow(updatedFlow);
                    return [2 /*return*/];
            }
        });
    }); }, [selectedFlow]);
    var onUnMarkAsTemplate = useCallback(function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, unMarkAsTemplate(flowId)];
                case 1:
                    _a.sent();
                    updatedFlow = __assign(__assign({}, selectedFlow), { isWorkspaceTemplate: false });
                    setSelectedFlow(updatedFlow);
                    onSaveFlow(updatedFlow);
                    return [2 /*return*/];
            }
        });
    }); }, [selectedFlow]);
    // const handleFlowNameClick = useCallback(() => {
    //   setIsFlowNameEditing(true);
    // }, []);
    var handleFlowNameChange = useCallback(function (event) {
        setFlowName(event.target.value);
    }, []);
    var selectFlow = useCallback(function (flowId) {
        searchParams.set("id", flowId.toString());
        setSearchParams(searchParams);
        setFlowShouldBeSaved(true);
    }, [searchParams, setSearchParams]);
    //Configuration
    var handleDescriptionChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowDescription: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleEndPointingChange = useCallback(function (event, newValue) {
        var value = newValue;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { endPointing: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHidePIIDataChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { hidePIIData: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseTypingSoundDataChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { useTypingSound: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleDoNotRecordCallsDataChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { doNotRecordCalls: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleOptOutChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { optOut: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleLLMModelNameChange = useCallback(function (event, newValue) {
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { llmModelName: newValue })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleVoiceChange = useCallback(function (event, selectedVoice) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { voiceId: selectedVoice.id, voice: selectedVoice }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Prompts
    var handleWelcomeMessageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowWelcomeMessage: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleIntroductionChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowIntroduction: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleInstructionChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowInstruction: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleFAQChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { faqSection: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSupportedLanguageChange = useCallback(function (event, value) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { supportedLanguages: value }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleResetToTemplateFlowChange = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedFlowId, sourceFlow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedFlowId = searchParams.get("id");
                    return [4 /*yield*/, getTemplateFlow(selectedFlowId)];
                case 1:
                    sourceFlow = _a.sent();
                    if (sourceFlow) {
                        setSelectedFlow(function (prevFlow) {
                            return (__assign(__assign({}, prevFlow), { faqSection: sourceFlow.faqSection }));
                        });
                        setResetToTemplate(true);
                        setInfoMessageOpen(true);
                        setInfoMessage("Click Save to apply your changes");
                        setFlowShouldBeSaved(true);
                    }
                    else {
                        setErrorMessage("The industry template has been removed and cannot be used.");
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [searchParams]);
    // HubSpot
    var handleHubSpotIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotDeploymentConfig: __assign(__assign({}, prevFlow.hubSpotDeploymentConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotUserIdChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotDeploymentConfig: __assign(__assign({}, prevFlow.hubSpotDeploymentConfig), { doworkUserIdInHubspot: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotActivationMessageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotDeploymentConfig: __assign(__assign({}, prevFlow.hubSpotDeploymentConfig), { activationMessage: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Knowledge Base
    var handleIsKnowledgeBaseEnabled = useCallback(function (event) {
        setIsKnowledgeBaseEnabled(event.target.checked);
        if (event.target.checked) {
            if (!(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.useKnowledgeBasePlugin) &&
                !(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.stepByStepTroubleshootingPlugin)) {
                setSelectedFlow(function (prevFlow) {
                    return (__assign(__assign({}, prevFlow), { useKnowledgeBasePlugin: true, stepByStepTroubleshootingPlugin: false }));
                });
            }
        }
        else {
            setSelectedFlow(function (prevFlow) {
                return (__assign(__assign({}, prevFlow), { useKnowledgeBasePlugin: false, stepByStepTroubleshootingPlugin: false }));
            });
        }
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseKnowledgeBaseChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useKnowledgeBasePlugin: checked, stepByStepTroubleshootingPlugin: !checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseUploadedFilesChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useUploadedFiles: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseWebsiteContentChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useWebsiteContent: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseAutoGeneratedArticlesChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useAutoGeneratedArticles: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseAutoGeneratedInstructionsChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useAutoGeneratedInstructions: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseDraftAutoGeneratedContentChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useDraftAutoGeneratedContent: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleStepByStepTroubleshootingPluginChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { stepByStepTroubleshootingPlugin: checked, useKnowledgeBasePlugin: !checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //SIP
    var handleSIPIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSIPConfigurationUpdate = useCallback(function (config) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { id: config.id }) }));
        });
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { domainName: config.domainName }) }));
        });
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { userName: config.userName }) }));
        });
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { password: config.password }) }));
        });
    }, []);
    //SIP REEFER
    var handleSIPEscalationIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipEscalationConfig: __assign(__assign({}, prevFlow.sipEscalationConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSIPReferURIChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipEscalationConfig: __assign(__assign({}, prevFlow.sipEscalationConfig), { sipBackUrl: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Call Forwarding
    var handleCallForwardingEscalationNumberChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { callForwardingEscalationConfig: __assign(__assign({}, prevFlow.callForwardingEscalationConfig), { forwardToNumber: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleCallForwardingEscalationIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { callForwardingEscalationConfig: __assign(__assign({}, prevFlow.callForwardingEscalationConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //HubSpot Ticket
    var handleHubSpotEscalationIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotTicketPipelineChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { ticketHsPipeline: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotTicketPipelineStageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { ticketHsPipelineStage: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotTicketPriorityChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { ticketHsTicketPriority: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Data Collection
    var handlePluginNameChange = useCallback(function (pluginIndex, event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex ? __assign(__assign({}, plugin), { pluginName: value }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginIsEnabledChange = useCallback(function (pluginIndex, isEnabled) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex ? __assign(__assign({}, plugin), { isEnabled: isEnabled }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleNewPlugin = useCallback(function () {
        if (!selectedFlow)
            return;
        var newPlugin = {
            id: 0,
            isEnabled: true,
            flowId: selectedFlow.id,
            pluginType: "DataCollectionPlugin",
            pluginName: "New Plugin",
            pluginVariables: [],
            startWithFirstVariableQuestion: false,
            pluginAction: {
                type: "webhook",
                executeAfterEachVariableSet: false,
                injectResult: true,
                actionDescription: "",
                args: "",
                argsObject: {
                    httpMethod: "POST",
                    url: "",
                    headers: {},
                    authorizationType: "",
                    apiKey: "",
                    username: "",
                    password: "",
                    usernameFieldName: "",
                    passwordFieldName: "",
                    accessTokenUrl: "",
                    accessTokenHttpMethod: "POST",
                    accessTokenFieldName: "",
                },
            },
        };
        setSelectedFlow(function (prevFlow) {
            return __assign(__assign({}, prevFlow), { plugins: __spreadArray(__spreadArray([], prevFlow.plugins, true), [newPlugin], false) });
        });
        setFlowShouldBeSaved(true);
    }, [selectedFlow]);
    var handlePluginVariablePropertyChange = useCallback(function (pluginIndex, variableIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                var _a;
                                return j === variableIndex
                                    ? __assign(__assign({}, variable), (_a = {}, _a[propertyName] = newValue, _a)) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginNewVariable = useCallback(function (pluginIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: __spreadArray(__spreadArray([], plugin.pluginVariables, true), [
                                { type: "string", enumValues: [] },
                            ], false) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginDeleteVariable = useCallback(function (pluginIndex, variableIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.filter(function (_, j) { return j !== variableIndex; }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionTypeChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { type: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginExecuteAfterChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { executeAfterEachVariableSet: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginInjectResultChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { injectResult: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionDescriptionChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { actionDescription: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsPropertyChange = useCallback(function (pluginIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    var _a;
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), (_a = {}, _a[propertyName] = newValue, _a)) }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsNewHeader = useCallback(function (pluginIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    var _a;
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { headers: __assign(__assign({}, plugin.pluginAction.argsObject.headers), (_a = {}, _a[""] = "", _a)) }) }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsUpdateHeader = useCallback(function (pluginIndex, headerKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedHeaders = __assign({}, plugin.pluginAction.argsObject.headers);
                    if (updateType === "key") {
                        // Update the key by creating a new entry and deleting the old one
                        if (Object.prototype.hasOwnProperty.call(updatedHeaders, headerKey)) {
                            var headerValue = updatedHeaders[headerKey];
                            delete updatedHeaders[headerKey];
                            updatedHeaders[newValue] = headerValue;
                        }
                    }
                    else if (updateType === "value") {
                        // Update the value directly
                        updatedHeaders[headerKey] = newValue;
                    }
                    return __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsDeleteHeader = useCallback(function (pluginIndex, headerKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedHeaders = __assign({}, plugin.pluginAction.argsObject.headers);
                    delete updatedHeaders[headerKey];
                    return __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableAddEnumValue = useCallback(function (pluginIndex, varIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, vi) {
                                return vi === varIndex
                                    ? __assign(__assign({}, variable), { enumValues: __spreadArray(__spreadArray([], variable.enumValues, true), [{}], false) }) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableUpdateEnumValue = useCallback(function (pluginIndex, varIndex, enumValueIndex, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedEnumValues = plugin.pluginVariables[varIndex].enumValues.map(function (enumValue, evi) {
                        if (evi !== enumValueIndex) {
                            return enumValue;
                        }
                        return updateType === "value"
                            ? __assign(__assign({}, enumValue), { value: newValue }) : __assign(__assign({}, enumValue), { display: newValue });
                    });
                    return __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, vi) {
                            return vi === varIndex
                                ? __assign(__assign({}, variable), { enumValues: updatedEnumValues }) : variable;
                        }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableDeleteEnumValue = useCallback(function (pluginIndex, varIndex, enumValueIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedEnumValues = plugin.pluginVariables[varIndex].enumValues.filter(function (_, evi) { return evi !== enumValueIndex; });
                    return __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, vi) {
                            return vi === varIndex
                                ? __assign(__assign({}, variable), { enumValues: updatedEnumValues }) : variable;
                        }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //conversationFlowPostCallActions
    var handleNewPostCallAction = useCallback(function () {
        try {
            if (!selectedFlow) {
                console.warn("No selectedFlow available");
                return;
            }
            var newAction_1 = {
                id: 0,
                isEnabled: true,
                flowId: selectedFlow.id,
                postCallAction: {
                    type: "webhook",
                    args: "",
                    postCallExecutionDelayInSeconds: 0,
                    argsObject: {
                        httpMethod: "POST",
                        url: "",
                        headers: {},
                        authorizationType: "",
                        apiKey: "",
                        username: "",
                        password: "",
                        usernameFieldName: "",
                        passwordFieldName: "",
                        accessTokenUrl: "",
                        accessTokenHttpMethod: "POST",
                        accessTokenFieldName: "",
                    },
                },
            };
            setSelectedFlow(function (prevFlow) {
                if (!prevFlow) {
                    console.warn("Previous flow is null or undefined");
                    return prevFlow;
                }
                var updatedFlow = __assign(__assign({}, prevFlow), { postCallActions: __spreadArray(__spreadArray([], prevFlow.postCallActions, true), [newAction_1], false) });
                return updatedFlow;
            });
            setFlowShouldBeSaved(true);
        }
        catch (error) {
            console.error("Error occurred in handleNewPostCallAction:", error);
        }
    }, [selectedFlow]);
    var handlePostCallActionDelete = useCallback(function (actionIndex) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow; // Return early if prevFlow is not set
            // Remove the post call action at the specified index
            var updatedPostCallActions = prevFlow.postCallActions.filter(function (_, index) { return index !== actionIndex; });
            return __assign(__assign({}, prevFlow), { postCallActions: updatedPostCallActions });
        });
        setFlowShouldBeSaved(true); // Mark the flow as needing to be saved
    }, []);
    var handlePostCallActionTypeChange = useCallback(function (actionIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow; // Return early if prevFlow is not set
            return __assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    return i === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { type: newValue, argsObject: getArgsObject(newValue) }) }) : action;
                }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsPropertyChange = useCallback(function (actionIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            var _a;
            var updatedFlow = __assign(__assign({}, prevFlow), { postCallActions: (_a = prevFlow === null || prevFlow === void 0 ? void 0 : prevFlow.postCallActions) === null || _a === void 0 ? void 0 : _a.map(function (action, index) {
                    var _a;
                    return index === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), (_a = {}, _a[propertyName] = newValue, _a)) }) }) : action;
                }) });
            return updatedFlow;
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsNewHeader = useCallback(function (actionIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    var _a;
                    return i === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), { headers: __assign(__assign({}, action.postCallAction.argsObject.headers), (_a = {}, _a[""] = "", _a)) }) }) }) : action;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsUpdateHeader = useCallback(function (actionIndex, headerKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    if (i !== actionIndex) {
                        return action;
                    }
                    var updatedHeaders = __assign({}, action.postCallAction.argsObject.headers);
                    if (updateType === "key") {
                        // Update the key by creating a new entry and deleting the old one
                        if (Object.prototype.hasOwnProperty.call(updatedHeaders, headerKey)) {
                            var headerValue = updatedHeaders[headerKey];
                            delete updatedHeaders[headerKey];
                            updatedHeaders[newValue] = headerValue;
                        }
                    }
                    else if (updateType === "value") {
                        // Update the value directly
                        updatedHeaders[headerKey] = newValue;
                    }
                    return __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsDeleteHeader = useCallback(function (actionIndex, headerKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    if (i !== actionIndex) {
                        return action;
                    }
                    var updatedHeaders = __assign({}, action.postCallAction.argsObject.headers);
                    delete updatedHeaders[headerKey];
                    return __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Conversation flow
    var onFlowSelect = function (flowId) {
        selectFlow(flowId);
    };
    var onNewFlow = function () { return __awaiter(void 0, void 0, void 0, function () {
        var templates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsTemplatesLoading(true);
                    return [4 /*yield*/, getTemplates()];
                case 1:
                    templates = _a.sent();
                    setSelectedTemplateFlowId(templates[1].id);
                    setIsNewAgentModalOpen(true);
                    setIsTemplatesLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onAddNewFlow = function () {
        var addNewFlow = function () { return __awaiter(void 0, void 0, void 0, function () {
            var flow;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsFlowAdding(true);
                        return [4 /*yield*/, createNewFlow(selectedTemplateFlowId)];
                    case 1:
                        flow = _a.sent();
                        return [4 /*yield*/, getFlows()];
                    case 2:
                        _a.sent();
                        selectFlow(flow.id);
                        setIsNewAgentModalOpen(false);
                        setIsFlowAdding(false);
                        return [2 /*return*/];
                }
            });
        }); };
        addNewFlow();
    };
    var validateModel = useCallback(function () {
        var _a, _b, _c, _d, _e, _f;
        var PLUGIN_NAME_REGEX = /^[a-zA-Z0-9_]+$/;
        var invalid = [];
        if ((_a = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _a === void 0 ? void 0 : _a.isEnabled) {
            if (!selectedFlow.hubSpotDeploymentConfig.activationMessage) {
                invalid.push({
                    field: "hubSpotDeploymentConfig.activationMessage",
                    error: "",
                });
            }
            if (!selectedFlow.hubSpotDeploymentConfig.doworkUserIdInHubspot) {
                invalid.push({
                    field: "hubSpotDeploymentConfig.doworkUserIdInHubspot",
                    error: "",
                });
            }
        }
        if ((_b = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sipEscalationConfig) === null || _b === void 0 ? void 0 : _b.isEnabled) {
            if (!selectedFlow.sipEscalationConfig.sipBackUrl) {
                invalid.push({ field: "sipEscalationConfig.sipBackUrl", error: "" });
            }
        }
        var flowWelcomeMessageLength = ((_c = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowWelcomeMessage) === null || _c === void 0 ? void 0 : _c.length) || 0;
        if (flowWelcomeMessageLength > 2000) {
            invalid.push({
                field: "prompts.flowWelcomeMessage",
                error: "Welcome Message section exceeds the maximum allowed character count of 2000. Current length is ".concat(flowWelcomeMessageLength, "."),
            });
        }
        var flowIntroductionLength = ((_d = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowIntroduction) === null || _d === void 0 ? void 0 : _d.length) || 0;
        if (flowIntroductionLength > 2000) {
            invalid.push({
                field: "prompts.flowIntroduction",
                error: "Introduction section exceeds the maximum allowed character count of 2000. Current length is ".concat(flowIntroductionLength, "."),
            });
        }
        var flowInstructionLength = ((_e = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowInstruction) === null || _e === void 0 ? void 0 : _e.length) || 0;
        if (flowInstructionLength > 20000) {
            invalid.push({
                field: "prompts.flowInstruction",
                error: "Instructions section exceeds the maximum allowed character count of 20000. Current length is ".concat(flowInstructionLength, "."),
            });
        }
        var faqLength = ((_f = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.faqSection) === null || _f === void 0 ? void 0 : _f.length) || 0;
        if (faqLength > 16000) {
            invalid.push({
                field: "prompts.faqSection",
                error: "FAQ section exceeds the maximum allowed character count of 16000. Current length is ".concat(faqLength, "."),
            });
        }
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.plugins.forEach(function (plugin, pluginIndex) {
            if (!plugin.pluginName) {
                invalid.push({ field: "plugins[".concat(pluginIndex, "].name"), error: "" });
            }
            else if (!PLUGIN_NAME_REGEX.test(plugin.pluginName)) {
                invalid.push({
                    field: "plugins[".concat(pluginIndex, "].name"),
                    error: "A plugin name can contain only letters, digits, and underscore.",
                });
            }
            plugin.pluginVariables.forEach(function (variable, varIndex) {
                if (!variable.name) {
                    invalid.push({
                        field: "plugins[".concat(pluginIndex, "].variables[").concat(varIndex, "].name"),
                        error: "",
                    });
                }
                if (!variable.label) {
                    invalid.push({
                        field: "plugins[".concat(pluginIndex, "].variables[").concat(varIndex, "].label"),
                        error: "",
                    });
                }
            });
        });
        setInvalidFields(invalid);
        return invalid.length === 0;
    }, [
        (_c = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _c === void 0 ? void 0 : _c.isEnabled,
        (_d = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _d === void 0 ? void 0 : _d.activationMessage,
        (_e = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _e === void 0 ? void 0 : _e.doworkUserIdInHubspot,
        (_f = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sipEscalationConfig) === null || _f === void 0 ? void 0 : _f.isEnabled,
        (_g = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sipEscalationConfig) === null || _g === void 0 ? void 0 : _g.sipBackUrl,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowWelcomeMessage,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowIntroduction,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowInstruction,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.faqSection,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.plugins,
    ]);
    var onSaveFlow = useCallback(function (flow) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlow, error_1, errors_1, errorMessages;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (validateModel() === false) {
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, 5, 6]);
                    setIsSaving(true);
                    updatedFlow = __assign(__assign({}, flow), { plugins: flow.plugins.map(function (plugin) { return (__assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { args: JSON.stringify(plugin.pluginAction.argsObject) }) })); }), postCallActions: flow.postCallActions.map(function (action) { return (__assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { args: JSON.stringify(action.postCallAction.argsObject) }) })); }) });
                    return [4 /*yield*/, updateFlow(updatedFlow)];
                case 2:
                    _c.sent();
                    return [4 /*yield*/, getFlows()];
                case 3:
                    _c.sent();
                    setInfoMessageOpen(true);
                    setInfoMessage("Your agent configuration has been saved.");
                    setErrorMessage(null);
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _c.sent();
                    if (axios.isAxiosError(error_1) && ((_b = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors)) {
                        errors_1 = error_1.response.data.errors;
                        errorMessages = Object.keys(errors_1)
                            .map(function (key) {
                            // Handle both array and string formats
                            if (Array.isArray(errors_1[key])) {
                                return errors_1[key].join(", ");
                            }
                            else if (typeof errors_1[key] === "string") {
                                return errors_1[key];
                            }
                            else {
                                return "An unknown error occurred.";
                            }
                        })
                            .join("<br>");
                        handleError(errorMessages);
                    }
                    else {
                        handleError("Something went wrong, please try again.");
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setIsSaving(false);
                    setFlowShouldBeSaved(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [getFlows, updateFlow, validateModel]);
    // const handleClickAway = useCallback(() => {
    //   if (isFlowNameEditing) {
    //     setIsFlowNameEditing(false);
    //     const updatedFlow = { ...selectedFlow, name: flowName } as IFlow;
    //     setSelectedFlow(updatedFlow);
    //     onSaveFlow(updatedFlow);
    //   }
    // }, [flowName, isFlowNameEditing, selectedFlow, onSaveFlow]);
    var handleError = function (errorMessage) {
        setErrorMessage(errorMessage);
    };
    useEffect(function () {
        var fetchFlows = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, selectedFlowId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFlows()];
                    case 1:
                        data = _a.sent();
                        setIsFlowsLoading(false);
                        selectedFlowId = searchParams.get("id");
                        if (selectedFlowId === null) {
                            if (data.length > 0) {
                                selectFlow(data[0].id);
                            }
                            else {
                                onNewFlow();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchFlows();
        getWidgetScript();
        getVoices();
    }, []);
    useEffect(function () {
        var _a, _b;
        var selectedFlowId = searchParams.get("id");
        var selectedFlow = flows.find(function (flow) { return flow.id === String(selectedFlowId); });
        if (selectedFlow) {
            selectedFlow = __assign(__assign({}, selectedFlow), { plugins: selectedFlow.plugins.map(function (plugin) { return (__assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: JSON.parse(plugin.pluginAction.args) }) })); }), postCallActions: selectedFlow.postCallActions.map(function (action) { return (__assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: JSON.parse(action.postCallAction.args) }) })); }) });
        }
        setSelectedFlow(selectedFlow !== null && selectedFlow !== void 0 ? selectedFlow : null);
        setFlowName((selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.name) || "");
        setIsKnowledgeBaseEnabled(((_a = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.useKnowledgeBasePlugin) !== null && _a !== void 0 ? _a : false) ||
            ((_b = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.stepByStepTroubleshootingPlugin) !== null && _b !== void 0 ? _b : false));
    }, [searchParams, flows]);
    useEffect(function () {
        // Cleanup function to remove the script when the component unmounts
        return function () {
            var widgetScript = document.getElementById("chat-widget-js");
            var script = document.getElementById("dowork-script");
            var websiteScript = document.getElementById("ask-website");
            localStorage.removeItem("DOWORK_SESSION_ID");
            if (widgetScript) {
                widgetScript.remove();
            }
            if (websiteScript) {
                document.body.removeChild(websiteScript);
            }
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, [location.pathname, searchParams]);
    return (_jsxs(Box, __assign({ display: "flex", overflow: "auto", height: "100vh" }, { children: [_jsx(Sidepane, { children: _jsx(AIAgentsList, { flows: flows, loading: isFlowsLoading, selectedFlowId: String(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.id), onFlowSelect: onFlowSelect }) }), _jsx(Modal, __assign({ open: isNewAgentModalOpen, onClose: function () { return setIsNewAgentModalOpen(false); }, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined", size: "lg", layout: "center" }, { children: [_jsx(ModalClose, {}), _jsx(DialogTitle, { children: "Add new Agent" }), _jsx(DialogContent, __assign({ sx: { p: 2 } }, { children: _jsxs(Stack, __assign({ spacing: 3 }, { children: [_jsx(RadioGroup, __assign({ "aria-label": "platform", overlay: true, name: "platform", sx: (_a = {
                                                flexDirection: "row",
                                                gap: 2
                                            },
                                            _a["& .".concat(radioClasses.checked)] = (_b = {},
                                                _b["& .".concat(radioClasses.action)] = {
                                                    inset: -1,
                                                    border: "3px solid",
                                                    borderColor: "primary.500",
                                                },
                                                _b),
                                            _a["& .".concat(radioClasses.radio)] = {
                                                display: "contents",
                                                "& > svg": {
                                                    zIndex: 2,
                                                    position: "absolute",
                                                    top: "-8px",
                                                    right: "-8px",
                                                    bgcolor: "background.surface",
                                                    borderRadius: "50%",
                                                },
                                            },
                                            _a) }, { children: _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: templates.map(function (template) { return (_jsx(Grid, __assign({ xs: 6 }, { children: _jsxs(Sheet, __assign({ variant: "outlined", sx: {
                                                        borderRadius: "md",
                                                        boxShadow: "sm",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: 1.5,
                                                        p: 2,
                                                        minWidth: 120,
                                                        height: 250,
                                                    } }, { children: [_jsx(Radio, { id: template.id, value: template.id, checkedIcon: _jsx(CheckCircleRoundedIcon, {}), checked: selectedTemplateFlowId === template.id, onChange: function () {
                                                                return setSelectedTemplateFlowId(template.id);
                                                            } }), _jsx(Typography, __assign({ level: "title-lg" }, { children: template.name })), _jsx(Typography, __assign({ level: "body-sm" }, { children: template.flowDescription }))] })) }), template.id)); }) })) })), _jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Button, __assign({ size: "md", variant: "solid", color: "primary", startDecorator: _jsx(CheckIcon, {}), loading: isFlowAdding, onClick: function () { return onAddNewFlow(); } }, { children: "Use Template" })) }))] })) }))] })) })), selectedFlow && (_jsxs(Box, __assign({ sx: {
                    flex: 1,
                    width: "100%",
                    overflow: "auto",
                } }, { children: [_jsxs(Box, __assign({ sx: {
                            position: "sticky",
                            top: { sm: -30, md: -20 },
                            bgcolor: "background.body",
                            pb: 1,
                            zIndex: 2,
                        } }, { children: [_jsx(Box, __assign({ sx: { px: { xs: 2, md: 6 } } }, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", sx: { pt: 2 } }, { children: [_jsx(Stack, { children: _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [_jsx(Typography, __assign({ level: "h3", sx: {
                                                            mt: 1,
                                                            mb: 2,
                                                            mr: 2,
                                                            color: "#626477",
                                                            size: "22px",
                                                        } }, { children: flowName })), (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.isSystemTemplate) && (_jsx(Chip, __assign({ color: "warning", variant: "outlined" }, { children: "System Template" }))), (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.isWorkspaceTemplate) && (_jsx(Chip, __assign({ color: "warning", variant: "outlined" }, { children: "Template" })))] })) }), _jsx(Stack, { direction: "row", spacing: 2, alignItems: "center" })] })) })), _jsx(Tabs, __assign({ defaultValue: 0, onChange: function (event, newValue) { return setTabIndex(Number(newValue)); }, sx: {
                                    bgcolor: "transparent",
                                    mb: 1,
                                } }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(TabList, __assign({ disableUnderline: true, size: "sm", sx: {
                                                pl: { xs: 0, md: 6 },
                                                gap: 1,
                                                "& .MuiTab-root": {
                                                    height: "37px",
                                                    borderRadius: "7px",
                                                    padding: "10px",
                                                    color: "#266CC7",
                                                    border: "0.5px solid",
                                                    borderColor: "#266CC7",
                                                    bgcolor: "transparent",
                                                    "&:hover": {
                                                        bgcolor: "primary.100", // Light blue background on hover
                                                    },
                                                    "&[aria-selected='true']": {
                                                        bgcolor: "#266CC7",
                                                        color: "white",
                                                        border: "0.5px solid",
                                                        borderRadius: "8px",
                                                        borderColor: "#266CC7",
                                                    },
                                                },
                                            } }, { children: [_jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, disableIndicator: true, value: 0 }, { children: "Knowledge Base" })), _jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, disableIndicator: true, value: 1 }, { children: "Data Collection" }))] })), _jsx(Stack, __assign({ sx: { pr: { xs: 0, md: 6 } } }, { children: _jsx(TwilioCallComponent, { flowId: selectedFlow.id }) }))] })) }))] })), _jsxs(Stack, __assign({ spacing: 4, sx: {
                            display: "flex",
                            mx: "auto",
                            px: { xs: 2, md: 6 },
                            py: { xs: 2, md: 3 },
                        } }, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 3, sx: { my: 1 } }, { children: [tabIndex === 0 && (_jsx(Prompts, { flow: selectedFlow, invalidFields: invalidFields, handleWelcomeMessageChange: handleWelcomeMessageChange, handleIntroductionChange: handleIntroductionChange, handleInstructionChange: handleInstructionChange, handleFAQChange: handleFAQChange, handleSupportedLanguageChange: handleSupportedLanguageChange, handleResetToTemplateFlowChange: handleResetToTemplateFlowChange })), tabIndex === 1 && (_jsx(Plugins, { flow: selectedFlow, invalidFields: invalidFields, isKnowledgeBaseEnabled: isKnowledgeBaseEnabled, onIsKnowledgeBaseEnabled: handleIsKnowledgeBaseEnabled, onStepByStepTroubleshootingPluginChange: handleStepByStepTroubleshootingPluginChange, onUseKnowledgeBaseChange: handleUseKnowledgeBaseChange, onUseUploadedFilesChange: handleUseUploadedFilesChange, onUseAutoGeneratedArticlesChange: handleUseAutoGeneratedArticlesChange, onUseWebsiteContentChange: handleUseWebsiteContentChange, onUseDraftAutoGeneratedContentChange: handleUseDraftAutoGeneratedContentChange, onUseAutoGeneratedInstructionsChange: handleUseAutoGeneratedInstructionsChange, onNewPlugin: handleNewPlugin, onPluginNameChange: handlePluginNameChange, onPluginIsEnabledChange: handlePluginIsEnabledChange, onPluginVariablePropertyChange: handlePluginVariablePropertyChange, onPluginNewVariable: handlePluginNewVariable, onPluginDeleteVariable: handlePluginDeleteVariable, onPluginActionTypeChange: handlePluginActionTypeChange, onPluginActionDescriptionChange: handlePluginActionDescriptionChange, onPluginExecuteAfterChange: handlePluginExecuteAfterChange, onPluginInjectResultChange: handlePluginInjectResultChange, onPluginActionArgsPropertyChange: handlePluginActionArgsPropertyChange, onPluginActionArgsNewHeader: handlePluginActionArgsNewHeader, onPluginActionArgsUpdateHeader: handlePluginActionArgsUpdateHeader, onPluginActionArgsDeleteHeader: handlePluginActionArgsDeleteHeader, onPluginVariableAddEnumValue: handlePluginVariableAddEnumValue, onPluginVariableUpdateEnumValue: handlePluginVariableUpdateEnumValue, onPluginVariableDeleteEnumValue: handlePluginVariableDeleteEnumValue }))] })), _jsx(Alert, __assign({ sx: { mt: "10px !important", mb: 0, backgroundColor: mode === "dark" ? "rgba(255, 244, 237, 0.3)" : "#FFF4ED", }, variant: "soft", startDecorator: _jsx(InfoIcon, {}) }, { children: _jsxs(Typography, __assign({ sx: { mt: 0 }, level: "body-sm" }, { children: ["To deploy this AI Agent, use the block of the agent in the IVR constructor of this product.", " "] })) })), _jsx(Stack, __assign({ width: 80, sx: { mt: "10px !important", ml: 0, pl: { xs: 0, md: 0 } } }, { children: flowShouldBeSaved &&
                                    (selectedFlow.isSystemTemplate ||
                                        selectedFlow.isWorkspaceTemplate ? (_jsx(Button, __assign({ variant: "soft", color: "warning", onClick: function () { return onSaveFlow(selectedFlow); }, loading: isSaving }, { children: "Save Template" }))) : (_jsx(_Fragment, { children: _jsx(Button, __assign({ color: "danger", variant: "solid", size: "sm", sx: {
                                                mb: 2,
                                                backgroundColor: mode === "dark" ? "#B55326" : "#EA6A30",
                                                "&:hover": {
                                                    backgroundColor: mode === "dark" ? "#A44C23" : "#D95A27",
                                                },
                                            }, onClick: function () { return onSaveFlow(selectedFlow); }, loading: isSaving }, { children: "Save" })) }))) }))] }))] }))), _jsx(Snackbar, __assign({ variant: "soft", color: "danger", open: errorMessage !== null, onClose: function () { return setErrorMessage(null); }, anchorOrigin: { vertical: "bottom", horizontal: "center" }, autoHideDuration: 3000, startDecorator: _jsx(ErrorIcon, {}), endDecorator: _jsx(Button, __assign({ onClick: function () { return setErrorMessage(null); }, size: "sm", variant: "soft", color: "danger" }, { children: "Dismiss" })) }, { children: errorMessage && (_jsx("div", { dangerouslySetInnerHTML: { __html: errorMessage } })) })), _jsx(Snackbar, __assign({ variant: "soft", sx: { zIndex: 9000000000000 }, color: "success", open: isInfoMessageOpen, onClose: function () { return setInfoMessageOpen(false); }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                }, autoHideDuration: 30000, startDecorator: _jsx(DoneIcon, {}), endDecorator: _jsx(Button, __assign({ onClick: function () {
                        setInfoMessageOpen(false);
                        setInfoMessage("");
                    }, size: "sm", variant: "soft", color: "success" }, { children: "Dismiss" })) }, { children: infoMessage }))] })));
};
